import React from 'react'

export default function ErrorComponent({msg}) {
  return (
    <div>{msg}</div>
  )
}
